// Deep compare two objects.  Used for comparing registrations while ignoring undefined properties.
export function deepCompare(obj1, obj2) {
    // Check if the objects are of the same type
    if (typeof obj1 !== typeof obj2) {
        return false;
    }
    // Handle null or non-object values
    if (obj1 === null || typeof obj1 !== "object") {
        return obj1 === obj2;
    }
    // Get the property names of the objects, ignore undefined properties
    const keys1 = Object.keys(obj1).filter((key) => obj1[key] !== undefined);
    const keys2 = Object.keys(obj2).filter((key) => obj2[key] !== undefined);
    // Check if the number of properties is the same
    if (keys1.length !== keys2.length) {
        return false;
    }
    // Compare each property recursively
    for (let key of keys1) {
        if (!deepCompare(obj1[key], obj2[key])) {
            return false;
        }
    }
    // If all properties match
    return true;
}
